import { render, staticRenderFns } from "./dr-content-header-component.vue?vue&type=template&id=1612f5be"
import script from "./dr-content-header-component.vue?vue&type=script&lang=js"
export * from "./dr-content-header-component.vue?vue&type=script&lang=js"
import style0 from "./dr-content-header-component.vue?vue&type=style&index=0&id=1612f5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports